module.exports = __webpack_public_path__ + "img/marker-oil-produce-empty.6cefd028.png";